/**
 * Check if object has any spell check errors (with or without replacements)
 * @param {fabric.Object} obj
 * @returns {boolean}
 */
export const hasSpellCheckErrors = (obj) => {
  if (!obj || obj.type !== 'textbox') {
    return false;
  }

  // Use the SpellCheckTextbox method if available
  if (typeof obj.hasSpellCheckErrors === 'function') {
    return obj.hasSpellCheckErrors();
  }

  // Fallback for regular textboxes
  return obj.spellCheckResults?.matches?.length > 0;
};
